import dayjs from 'dayjs';

import { QuotesDashboardDateRange } from 'reports/components';
import { IQuotesDashboardDetailsItem } from 'reports/types';

export const isMonthlyAggregation = (dateRange: QuotesDashboardDateRange): boolean => {
  return (
    dateRange === QuotesDashboardDateRange.YEAR_TO_DATE ||
    dateRange === QuotesDashboardDateRange.PREVIOUS_YEAR
  );
};

export const aggregateToMonthly = (
  items: IQuotesDashboardDetailsItem[]
): IQuotesDashboardDetailsItem[] => {
  const monthlyMap = new Map<string, IQuotesDashboardDetailsItem>();

  items.forEach((item) => {
    const monthKey = dayjs(item.date).format('YYYY-MM');

    const monthItem = monthlyMap.get(monthKey) || { count: 0, totalCost: 0, totalPrice: 0 };

    monthlyMap.set(monthKey, {
      count: monthItem.count + item.count,
      date: monthKey,
      totalCost: monthItem.totalCost + item.totalCost,
      totalPrice: monthItem.totalPrice + item.totalPrice,
    });
  });

  return Array.from(monthlyMap.values()).sort((a, b) => a.date.localeCompare(b.date));
};

export const formatLabel = (date: string, isMonthly: boolean): string => {
  const parsedDate = dayjs(date);

  if (isMonthly) {
    return parsedDate.format('MMM');
  }

  return parsedDate.format('D');
};
